import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import PublicHeader from '../components/PublicHeader';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader title="Datenschutz" showBackButton={false} />

      <div className="container mx-auto px-4 py-12">
        <Link to="/">
          <Button variant="outline" className="mb-8 border-[#2C3E50] hover:bg-[#FDB913] hover:text-[#1a1a1a]">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Zurück zur Startseite
          </Button>
        </Link>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-[#2C3E50] mb-8">Datenschutzerklärung</h1>
          
          <div className="space-y-8 text-gray-700">
            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">1. Datenschutz auf einen Blick</h2>
              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Allgemeine Hinweise</h3>
              <p className="mb-4">
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">2. Datenerfassung auf dieser Website</h2>
              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Wer ist verantwortlich für die Datenerfassung?</h3>
              <p className="mb-4">
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber:<br /><br />
                <strong>Hogir Acar</strong><br />
                Breslauer Str. 21<br />
                54516 Wittlich<br />
                Telefon: +49 173 4611527<br />
                E-Mail: info@hogiracar.com
              </p>

              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Wie erfassen wir Ihre Daten?</h3>
              <p className="mb-4">
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
              </p>

              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Wofür nutzen wir Ihre Daten?</h3>
              <p className="mb-4">
                Wir verarbeiten personenbezogene Daten (Name, E-Mail, Telefonnummer) ausschließlich zur Bearbeitung Ihrer Anfrage und zur Kontaktaufnahme im Rahmen unserer Geschäftstätigkeit.
              </p>

              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Welche Rechte haben Sie bezüglich Ihrer Daten?</h3>
              <p>
                Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">3. Kontaktformular</h2>
              <p className="mb-4">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <p>
                Eine Weitergabe an Dritte erfolgt nicht, es sei denn, dies ist zur Vertragserfüllung erforderlich oder gesetzlich vorgeschrieben.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">4. Ihre Rechte</h2>
              <p className="mb-4">
                Sie haben das Recht:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Auskunft über Ihre bei uns gespeicherten Daten zu verlangen</li>
                <li>Die Berichtigung unrichtiger Daten zu verlangen</li>
                <li>Die Löschung Ihrer Daten zu verlangen</li>
                <li>Die Einschränkung der Verarbeitung zu verlangen</li>
                <li>Der Verarbeitung zu widersprechen</li>
                <li>Auf Datenübertragbarkeit</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">5. Datensicherheit</h2>
              <p>
                Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre durch uns verwalteten Daten gegen Manipulation, Verlust, Zerstörung und gegen den Zugriff unberechtigter Personen zu schützen.
              </p>
            </div>

            <div className="bg-[#FDB913]/10 p-6 rounded-lg border-l-4 border-[#FDB913]">
              <h3 className="text-xl font-semibold text-[#2C3E50] mb-2">Kontakt bei Datenschutzfragen</h3>
              <p>
                Bei Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten, bei Auskünften, Berichtigung, Sperrung oder Löschung von Daten wenden Sie sich bitte an:
              </p>
              <p className="mt-2">
                <strong>Hogir Acar</strong><br />
                Breslauer Str. 21, 54516 Wittlich<br />
                E-Mail: info@hogiracar.com<br />
                Telefon: +49 173 4611527
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;